<template>
  <nav>
    <router-link to="/" class="navbar-logo">
      <img src="@/assets/Topic.png" alt="國立政治大學校務研究辦公室" />
    </router-link>
    <input type="checkbox" class="nav-toggle" id="nav-toggle" />
    <div class="navbar">
      <ul>
        <li><router-link to="/" >{{ $t("overview") }}</router-link></li>
        <li><router-link to="/news" :class="{ 'router-link-active': pathname == '/newsDetail' }">{{ $t("news") }}</router-link></li>
        <li><router-link to="/about">{{ $t("about") }}</router-link></li>
        <li v-if="this.$i18n.locale == 'zh'" class="drop-down-menu">
          <router-link to="/info" :class="{ 'router-link-active': pathname == '/overview' || pathname == '/dataVisualizationPortal' || pathname == '/dataVisualization' }">校務資訊</router-link>
          <ul>
            <li><router-link to="/overview">歷年政大概覽</router-link></li>
            <!-- <li><router-link to="/datavisualization" :class="{ 'router-link-active': pathname == '/dataVisualization' }">校務資料視覺化</router-link></li> -->
            <li><router-link to="/info">校務資料運用</router-link></li>
          </ul>
        </li>

        <li v-if="this.$i18n.locale == 'zh'" class="drop-down-menu">
          <router-link to="/research">{{ $t("research") }}</router-link>
          <ul class="research-menu">
            <li><router-link :to="{ name: 'research', hash: '#重點成果展示' }">重點成果展示</router-link></li>
            <li><router-link :to="{ name: 'research', hash: '#歷年分析列表' }">歷年分析列表</router-link></li>
            <li><router-link :to="{ name: 'research', hash: '#校發徵件' }">校發徵件</router-link></li>
          </ul>
        </li>
        <li v-if="this.$i18n.locale == 'en'" class="drop-down-menu">
          <router-link :to="{ name: 'findings' }">{{ $t("research") }}</router-link>
        </li>

        <li v-if="this.$i18n.locale == 'zh'"><router-link to="/surveys">問卷調查</router-link></li>
        <li v-if="this.$i18n.locale == 'zh'"><router-link to="/laws">相關法規</router-link></li>
        <li v-if="this.$i18n.locale == 'zh'"><router-link to="/downloads">表單下載</router-link></li>
        <li><router-link to="/links">{{ $t("links") }}</router-link></li>

        <!-- <li>
          <router-link class="lan-toggle" to="/" >
            <span v-if="this.$i18n.locale == 'en'" class="lan" @click="changeLanuage('zh')"><font-awesome-icon :icon="['fas', 'earth-americas']" /> 中文</span>
            <span v-if="this.$i18n.locale == 'zh'" class="lan" @click="changeLanuage('en')"><font-awesome-icon :icon="['fas', 'earth-americas']" /> English</span>
          </router-link>
        </li> -->
      </ul>
    </div>
    <label for="nav-toggle" class="nav-toggle-label">
      <span></span>
    </label>
    <div class="nav-bottom"></div>
  </nav>
</template>

<script>
import {useRoute} from 'vue-router'
import {useI18n} from 'vue-i18n';
import { registerRuntimeCompiler } from 'vue';

export default {

  data() {
    return {
      pathname: "/",
    }
  },

  methods: {
    changeLanuage (lang) {
      this.$i18n.locale = lang

      // this.$router.push({
      //   query: { lang } 
      // });
    },
  },

  mounted() {
    this.pathname += useRoute().matched[0].name;
  }

}
</script>

<style src="@/assets/css/navbar.css" scoped></style>
